import { render, staticRenderFns } from "./DeliveryShowResultMedia.vue?vue&type=template&id=280a49f1"
import script from "./DeliveryShowResultMedia.vue?vue&type=script&lang=ts"
export * from "./DeliveryShowResultMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports